import { ReactComponent as ArrowDown } from '../../../assets/icons/ArrowDown.svg';

import classes from './ArrowButton.module.scss';

const ArrowButton = ({ open: externalOpen, onClick, name, className }) => {
  const arrowClasses = [classes.arrow];
  if (externalOpen) {
    arrowClasses.push(classes['arrow-open']);
  }

  className && arrowClasses.push(className);

  return <ArrowDown name={name} className={arrowClasses.join(' ')} onClick={onClick} />;
};

export default ArrowButton;
